import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 10.61 10.61",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.61 10.61\" id=\"icon-delete\"><defs><style>#icon-delete .cls-1{opacity:0.5;}#icon-delete .cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}</style></defs><g id=\"icon-delete_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-delete_圖層_1-2\" data-name=\"圖層 1\"><g class=\"cls-1\"><line class=\"cls-2\" x1=\"0.71\" y1=\"9.9\" x2=\"9.9\" y2=\"0.71\" /><line class=\"cls-2\" x1=\"9.9\" y1=\"9.9\" x2=\"0.71\" y2=\"0.71\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol